export const REACTIONS: ReadonlyArray<{ value: number; emoji: string; label: string }> = [
  { value: 1, emoji: '😕', label: 'Мимо' },
  { value: 2, emoji: '🤔', label: 'Задумался' },
  { value: 3, emoji: '🙂', label: 'Похоже' },
  { value: 4, emoji: '🎯', label: 'В точку' },
  { value: 5, emoji: '🥹', label: 'До мурашек' },
]

export function reactionEmoji(value: number | null | undefined): string | null {
  return REACTIONS.find((item) => item.value === value)?.emoji ?? null
}

export const REACTION_ADD_ICON = {
  circles: [
    { cx: 11, cy: 12, r: 8 },
    { cx: 8.8, cy: 10, r: 0.6 },
    { cx: 13.4, cy: 10, r: 0.6 },
  ],
  paths: ['M8 13.5c.9 1.3 2.1 2 3.3 2s2.2-.7 3-2', 'M19 4v4M17 6h4'],
} as const
